var map = {
	"./amplify-amazon-button_5.entry.js": [
		64970,
		262,
		970
	],
	"./amplify-auth-container.entry.js": [
		82257,
		257
	],
	"./amplify-auth-fields_9.entry.js": [
		65497,
		497
	],
	"./amplify-authenticator.entry.js": [
		19134,
		262,
		134
	],
	"./amplify-button_3.entry.js": [
		72139,
		139
	],
	"./amplify-chatbot.entry.js": [
		63037,
		37
	],
	"./amplify-checkbox.entry.js": [
		50920,
		920
	],
	"./amplify-confirm-sign-in_7.entry.js": [
		53177,
		262,
		177
	],
	"./amplify-container.entry.js": [
		99950,
		950
	],
	"./amplify-federated-buttons_2.entry.js": [
		27308,
		262,
		308
	],
	"./amplify-federated-sign-in.entry.js": [
		91599,
		599
	],
	"./amplify-form-field_4.entry.js": [
		49941,
		262,
		941
	],
	"./amplify-greetings.entry.js": [
		25473,
		262,
		473
	],
	"./amplify-icon-button.entry.js": [
		64053,
		53
	],
	"./amplify-icon.entry.js": [
		77800,
		800
	],
	"./amplify-link.entry.js": [
		77229,
		229
	],
	"./amplify-nav_2.entry.js": [
		9657,
		262,
		657
	],
	"./amplify-photo-picker.entry.js": [
		18520,
		520
	],
	"./amplify-picker.entry.js": [
		7399,
		399
	],
	"./amplify-radio-button_3.entry.js": [
		89769,
		262,
		769
	],
	"./amplify-s3-album.entry.js": [
		27645,
		585,
		645
	],
	"./amplify-s3-image-picker.entry.js": [
		114,
		585,
		114
	],
	"./amplify-s3-image.entry.js": [
		79443,
		585,
		443
	],
	"./amplify-s3-text-picker.entry.js": [
		18534,
		585,
		534
	],
	"./amplify-s3-text.entry.js": [
		76543,
		585,
		543
	],
	"./amplify-select-mfa-type.entry.js": [
		10927,
		927
	],
	"./amplify-sign-in-button.entry.js": [
		14951,
		951
	],
	"./amplify-tooltip.entry.js": [
		44202,
		202
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(() => {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 67915;
module.exports = webpackAsyncContext;